import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    OnDestroy
} from '@angular/core';
import { ChartConfiguration, DoughnutControllerDatasetOptions } from 'chart.js/auto';
import { Icons } from '../../icon/constants/icons.constants';
import { IconComponent } from '../../icon/icon.component';
import { LogoLoadingComponent } from '../../logo-loading/logo-loading.component';
import { BaseChartComponent } from '../base/base-chart.component';
import { COLORS } from '../constants/chart.constants';

@Component({
    selector: 'nw-doughnut-chart',
    templateUrl: '../base/base-chart.component.html',
    styleUrl: '../base/base-chart.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, LogoLoadingComponent, IconComponent]
})
export class DoughnutChartComponent
    extends BaseChartComponent<'doughnut', DoughnutControllerDatasetOptions>
    implements OnDestroy, OnChanges
{
    @Input() centerLabel?: string | string[];

    public override icon: Icons.Type = Icons.Charts.pie;

    public override datasetDefaults = (): Partial<DoughnutControllerDatasetOptions> => {
        const COLORS: string[] = this.getColors();
        return {
            backgroundColor: COLORS,
            borderColor: this.theme === 'dark' ? '#17181c' : '#fff',
            borderWidth: 4,
            hoverBorderWidth: 0,
            hoverBackgroundColor: COLORS,
            borderAlign: 'center'
        };
    };

    public override configDefaults(): Partial<ChartConfiguration> {
        if (this.centerLabel) {
            return {
                type: 'doughnut',
                options: {
                    animation: false,
                    plugins: {
                        annotation: {
                            annotations: {
                                label1: {
                                    type: 'label',
                                    xValue: 0.5,
                                    yValue: 0.5,
                                    content:
                                        typeof this.centerLabel === 'string'
                                            ? [this.centerLabel]
                                            : this.centerLabel,
                                    font: {
                                        size: 18
                                    }
                                }
                            }
                        }
                    }
                }
            };
        }

        return {
            type: 'doughnut',
            options: {
                animation: false
            }
        };
    }

    private getColors(): string[] {
        const _COLORS: string[] = [...COLORS];
        let extendedArray: string[] = [];

        while (
            extendedArray.length <
            ((this.datasets?.length ? this.datasets[0] : undefined)?.data?.length || 0)
        ) {
            extendedArray = extendedArray.concat(_COLORS);
        }

        return extendedArray;
    }
}
